import replace from "lodash/replace";
import { vendorMaps, expertMaps } from "./verbageMaps";
export var replaceVerbiage = function (markup, vendor) {
    try {
        var replacedVendor = replace(markup, "{{vendorName}}", vendorMaps[vendor]);
        var replacedText = replace(replacedVendor, "{{expertName}}", expertMaps[vendor]);
        return replacedText;
    }
    catch (error) {
        console.error(error);
        return markup;
    }
};
